import React from "react";
import "./BookFalse.css";

function BookFalse(props) {
  const { rectangle32, bookServices, line16 } = props;

  return (
    <div className="accordian-5">
      <div className="frame-30">
        <div className="overlap-group-3">
          <div className="frame-31">
            <img className="rectangle-32-2" src={rectangle32} />
            <div className="book-services poppins-medium-tundora-16px">{bookServices}</div>
          </div>
          <img className="vector-2" src="/img/vector-2@2x.png" />
        </div>
      </div>
      <img className="line-16-1" src={line16} />
    </div>
  );
}

export default BookFalse;
